import React from "react";
import BlogImg from "../assets/images/Blog.png";
import "./Blog.css";
import { Container, Row, Col, Button } from 'react-bootstrap';

const Blog = () => {

    // blogData.js
    const blogPosts = [
        {
            id: 1,
            title: "Emphasizes the importance of continuous learning and intellectual",
            description:
                " Relar Residence promotes sustainable transportation options, with dedicated spaces. Welcome to Plots Verified Residence, where sustainability meets comfort in every corner. In this blog post, we’ll explore the green innovations seamlessly integrated into the fabric of EcoLand.",
            date: "June 9, 2024",
            author: "Plots Verified",
            category: "Property",
            image: BlogImg
        },
        {
            id: 2,
            title: "Enrich Your Mind Envision Your Future",
            description:
                "Welcome to Plots Verified Residence, where sustainability meets comfort  Relar Residence promotes sustainable transportation options, with dedicated spaces. Welcome to Plots Verified Residence, where sustainability meets comfort in every corner. In this blog post, we’ll explore the green innovations seamlessly integrated into the fabric of EcoLand.",
            date: "April 17, 2024",
            author: "Plots Verified",
            category: "Real Estate",
            image: BlogImg
        }
    ];


    return (
        <div className="blog-container home-container1">
            {/* Banner Section */}
            <div
                className="banner-section"
                style={{ backgroundImage: `url(${BlogImg})` }}
            >
                <div className="banner-overlay"></div>
                <div className="banner-content">
                    <h1>Latest News</h1>
                    <p className="breadcrumb-text">
                        <span>Home</span> <span className="arrow">→</span> <span>Blog</span>
                    </p>
                </div>
            </div>

            {/* Main Content */}
            <Container >
                <Row className="mt-5">
                    <Col lg={8} className="mb-3">
                        <div className="blog-main">
                            {/* Left Side - Blog Posts */}
                            {blogPosts.map((blogPost, index) => (
                                <div className="blog-posts" key={index}>
                                    <div className="post-card">
                                        <img src={blogPost.image} alt="Blog" className="post-image" />
                                        <div className="post-meta">
                                            <span>👤 {blogPost.author}</span>
                                            <span>📅 {blogPost.date}</span>
                                            <span>🏠︎ {blogPost.category}</span>
                                        </div>
                                        <a className="post-title" href={`/Blog/${encodeURIComponent(blogPost.title)}/${blogPost.id}`}>
                                            {blogPost.title}
                                        </a>
                                        <p className="post-desc">{blogPost.description}</p>
                                        <a href={`/Blog/${encodeURIComponent(blogPost.title)}/${blogPost.id}`}>
                                            <button className="read-btn">READ MORE</button>
                                        </a>
                                    </div>
                                </div>
                            ))}

                        </div>

                    </Col>
                    <Col sm={4} className="mb-3">
                        <aside className="blog-sidebar">
                            {/* Search */}
                            {/* <div className="sidebar-card search-box">
            <input type="text" placeholder="Search..." />
          </div> */}

                            {/* Categories */}
                            <div className="sidebar-card">
                                <h3>Post Categories</h3>
                                <ul>
                                    <li>Apartment (1)</li>
                                    <li>Banglow (2)</li>
                                    <li>Modern Houses (3)</li>
                                    <li>Property (5)</li>
                                    <li>Real Estate (5)</li>
                                </ul>
                            </div>

                            {/* Recent Posts */}
                            <div className="sidebar-card">
                                <h3>Recent Posts</h3>
                                <ul className="recent-posts">
                                    <li>
                                        <img src={BlogImg} alt="post" />
                                        <div>
                                            <p>Emphasizes The Importance Of Continuous Learning</p>
                                            <span>📅 June 9, 2024</span>
                                        </div>
                                    </li>
                                    <li>
                                        <img src={BlogImg} alt="post" />
                                        <div>
                                            <p>Enrich Your Mind Envision Your Future</p>
                                            <span>📅 April 17, 2024</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </aside>
                    </Col>
                </Row>
            </Container>


            {/* Right Side - Sidebar */}

        </div>

    );
};

export default Blog;
